// extracted by mini-css-extract-plugin
module.exports = {"Content":"MainContent_Content___FBfa","CategoryCard":"MainContent_CategoryCard__2OWd1"};